import React, { useState, useEffect } from 'react';
import { store } from '../../app/store';
import { postAPI } from '../../app/api';
import Sidebar from '../Universal/Sidebar';
import Header from '../Universal/Header';

export default function Exams() {
  const [IsBTNClicked, setIsBTNClicked] = useState(false);
  const store_data = JSON.parse(store());
  const [ExamData, setExamData] = useState([]);
  const [Loading, setLoading] = useState(true);

  const fetchExamData = async () => {
    const filter = { id: store_data?.org_id }
    const response = await postAPI("/exams/list", filter);
    if (response?.status) {
      setExamData(response?.data)
      setLoading(false)
    } else {
      setExamData([])
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchExamData();
  }, [])
  return (
    <>
      <div class="container-xxl flex-grow-1 container-p-y">
        <div class="row">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => { window.location.href = '/Admin/Setting/Exams'; }}>
              Back
            </button>
            <p className='text-right mb-0'><small className="fw-bold py-3">Dashboard<span className="text-muted fw-light"> / Exams List</span> </small></p>
          </div>
          {
            ExamData && ExamData.length > 0 ?
              ExamData?.map((val, index) => parseInt(val?.is_submit) ? '' : (
                <div class="col-md-6 col-xl-4 order-2 order-lg-1">
                  <div class="card" style={{ paddingBottom: "32px" }}>
                    <div class="card-body text-center">
                      <h5>{val?.exam_title}</h5>
                      <p className='mt-1'>Exam Date: {val?.date}</p>
                      <p className='mt-1'>Exam Portal Open Time : {val?.start_time}</p>
                      <p className='mt-1'>Exam Portal Close Time : {val?.end_time}</p>
                    </div>
                    <div class="card-footer text-center">
                      <button class="btn btn-primary waves-effect waves-light" type="button" onClick={() => { window.location.href = `/Exams/${val?.public_access_token}/${store_data?.org_id}/${store_data?.user_unique_id}/Live` }}>Start Test</button>
                    </div>
                  </div>
                </div>
              ))
              : ''
          }
        </div>
      </div>
    </>
  )
}
